// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="valutazione">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-lg-8 bg-overlay-black-10"></div>
                    <div className="col-12 col-lg-4 px-0">
                        <div className="bg-valuta">
                            <div className="text-center text-lg-right">
                                <h2 className="mb-4">{t('homePage.sellBanner.title')}</h2>
                                <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                                <Link className="btn btn-primary" to="/valutazione">
                                    <span>{t('homePage.sellBanner.btnText')}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;